import * as React from "react";
import { Checkbox, Typography } from "@tiny/components";
import { Box } from "@mui/material";
import { usePredefinedSegmentsContext } from "../PredefinedSegments.context";

const recommendedColors = [
  "fuchsia.dark",
  "yellow.dark",
  "blue.dark",
  "purple.dark",
];

function CardName({
  name,
  cardIndex,
  disabled = false,
}: {
  name: string;
  cardIndex: number;
  disabled?: boolean;
}) {
  const { isRecommended } = usePredefinedSegmentsContext();
  if (isRecommended) {
    return (
      <Box
        component="h5"
        color={recommendedColors[cardIndex % recommendedColors.length]}
        fontWeight={600}
        m={0}
        mb={1}
        fontSize={16}
        lineHeight="20px"
      >
        {name}
      </Box>
    );
  }
  return (
    <Typography
      variant="h4"
      color="grey"
      tone={disabled ? 700 : 900}
      fontWeight={disabled ? "regular" : "semiBold"}
      m={0}
      mb={1}
    >
      {name}
    </Typography>
  );
}

export { CardName };
